import { type FC, type MouseEventHandler } from 'react';
import type { IconName } from 'src/common/components/icon';
import { Icon } from 'src/common/components/icon';
import { useOpenModal } from 'src/common/components/next-modal';
import { Tooltip } from 'src/common/components/tooltip';
import { publicLink } from 'src/common/const';
import { IconUiSizeBox } from 'src/components/icon-ui-size-box';
import { SpaceCapacity } from 'src/components/space-capacity';
import { Modals } from 'src/modals';
import { bizTracker } from 'src/utils/biz-tracker';
import { ResourceCenter } from '../resource-center';
import { TrashPopup } from './trash';

// const KEY_HIDE_SUBSCRIBE_TIP = 'hide_subscribe_tip';
export const AsideFooter: FC<{}> = () => {
  // const { showOnce: subTip, close: setHideSubTip } = useOnceAnyDay(KEY_HIDE_SUBSCRIBE_TIP, {
  //   endDay: -1,
  // });
  const openModal = useOpenModal();

  const openTemplateCenter = () => {
    openModal.modal({
      modalId: Modals.TEMPLATE_CENTER,
      content: () => <ResourceCenter from="quickSetting" />,
    });
  };

  const renderList = [
    {
      title: '知识库',
      popup: '官方精选专栏',
      click: () => {
        bizTracker.event('knowledge', { is_from: 'cata_knowledge' });
        // setHideSubTip();
        window.open(publicLink.subscribeCenter);
      },
      icon: 'IcKnowledgeBase',
      hidden: __PRIVATE__ || __BUILD_IN__,
      // tip: subTip && <div className="text-t4 px-1.5 text-white-base bg-red rounded">🎉New</div>,
    },
    {
      title: '模板中心',
      popup: '社区精选模板',
      click: openTemplateCenter,
      icon: 'IcTemplate',
      hidden: __PRIVATE__,
    },
  ].filter((i) => !i.hidden);

  return (
    <div className="mt-auto">
      <SpaceCapacity type="aside" />
      <div
        className="grid text-t3-medium py-2 gap-2 px-2"
        style={{
          gridTemplateColumns: `repeat(${renderList.length}, minmax(0, 1fr))`,
        }}
      >
        {renderList.map((item, index) => (
          <Tooltip
            key={index}
            className="relative flex text-t3-medium items-center justify-center animate-hover-black3 space-x-2 px-1 py-2"
            popup={item.popup}
            onClick={item.click}
            placement="top"
          >
            <Icon className="text-grey3" name={item.icon as IconName} size="middle" />
            <span className="text-grey2">{item.title}</span>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};

export const AsideFooterToolList = () => {
  const openModal = useOpenModal();

  const handleOpen: MouseEventHandler = (event) => {
    bizTracker.event('recycle_click');
    openModal.dropdown({
      modalId: Modals.TRASH,
      popcorn: event.currentTarget,
      placement: 'right',
      content: () => <TrashPopup />,
    });
  };

  return (
    <div className="px-2">
      {[
        {
          title: '回收站',
          popup: '删除的页面及文件',
          click: handleOpen,
          icon: 'IcTrash',
        },
        // {
        //   title: '帮助中心',
        //   popup: '帮助中心',
        //   click: () => {
        //     bizTracker.event('help_centre');
        //     window.open(publicLink.helpCenter);
        //   },
        //   icon: 'IcQuestionMiddleBold',
        // },
      ].map((item) => (
        <Tooltip
          className="text-grey3 h-8 flex items-center text-t2-medium px-2.5 animate-hover animate-click space-x-1"
          key={item.title}
          onClick={item.click}
        >
          <IconUiSizeBox size={20}>
            <Icon size="small" name={item.icon as IconName} />
          </IconUiSizeBox>
          <div>{item.title}</div>
        </Tooltip>
      ))}
    </div>
  );
};
